<section class="page-card session-create-card">
  <app-back-button-component />

  <h2 class="section-title">Create Session</h2>
  <p class="empty-copy">
    Name the session, describe it, then choose the universe where the session resides and the
    campaign being played.
  </p>

  @if (loadUniversesError()) {
    <p class="validation-text">{{ loadUniversesError() }}</p>
  }

  <div class="session-create-grid">
    <label class="form-group">
      <span>Session Name</span>
      <input
        [ngModel]="sessionName()"
        (ngModelChange)="updateSessionName($event)"
        placeholder="Enter session name"
        required
      />
    </label>

    <label class="form-group">
      <span>Universe Name</span>
      <select
        [ngModel]="selectedUniverseId()"
        (ngModelChange)="onUniverseChange($event)"
        [disabled]="isLoadingUniverses()"
        required
      >
        <option value="">
          {{ isLoadingUniverses() ? 'Loading universes...' : 'Choose a universe' }}
        </option>
        @for (universe of universes(); track universe.id) {
          <option [value]="universe.id">{{ universe.name }}</option>
        }
      </select>
    </label>

    <label class="form-group">
      <span>Campaign</span>
      <select
        [ngModel]="selectedCampaignId()"
        (ngModelChange)="onCampaignChange($event)"
        [disabled]="isLoadingUniverses() || !selectedUniverse() || !availableCampaigns().length"
        required
      >
        <option value="">Choose a campaign</option>
        @for (campaign of availableCampaigns(); track campaign.id) {
          <option [value]="campaign.id">{{ campaign.name }}</option>
        }
      </select>
    </label>
  </div>

  <label class="form-group session-description-field">
    <span>Session Description</span>
    <textarea
      rows="4"
      [ngModel]="sessionDescription()"
      (ngModelChange)="updateSessionDescription($event)"
      placeholder="Describe what this session is about"
      required
    ></textarea>
  </label>

  @if (isLoadingUniverses()) {
    <div class="session-create-loader">
      <app-loading-component
        [flavorTextOptions]="[
          'Opening the universe index for your next session.',
          'Finding campaigns that belong to your worlds.',
          'Preparing the session ledger for review.'
        ]"
      />
    </div>
  }

  @if (selectedUniverse() && !availableCampaigns().length) {
    <p class="empty-copy">
      This universe does not have any campaigns yet.
    </p>
  }

  @if (availableCampaigns().length) {
    <div class="campaign-pick-grid">
      @for (campaign of availableCampaigns(); track campaign.id) {
        <button
          type="button"
          class="campaign-pick"
          [class.is-selected]="selectedCampaignId() === campaign.id"
          (click)="chooseCampaign(campaign)"
        >
          <app-campaign-card-component
            [campaign]="campaign"
            [universeName]="selectedUniverse()?.name || ''"
          />
        </button>
      }
    </div>
  }

  <div class="button-row">
    <button
      type="button"
      class="primary-btn"
      [disabled]="!canReviewSession()"
      (click)="openRecap()"
    >
      Create Session
    </button>
    <a class="secondary-btn" [routerLink]="['/sessions']">Back To Sessions</a>
  </div>

  @if (createSessionError()) {
    <p class="validation-text">{{ createSessionError() }}</p>
  }

  @if (isRecapOpen() && selectedUniverse() && selectedCampaign()) {
    <section class="session-recap">
      <div class="section-kicker">Recap</div>
      <h3>Review Session</h3>
      <p class="empty-copy">
        You are about to create a session for this campaign with
        {{ auth.currentUser()?.name || 'Unknown Master' }} as the master.
      </p>

      <div class="session-recap-detail">
        <strong>Session Name:</strong>
        <span>{{ sessionName() }}</span>
      </div>

      <div class="session-recap-detail session-recap-description">
        <strong>Session Description:</strong>
        <span>{{ sessionDescription() }}</span>
      </div>

      <div class="session-recap-detail">
        <strong>Universe Name:</strong>
        <span>{{ selectedUniverse()?.name }}</span>
      </div>

      <app-campaign-card-component
        [campaign]="selectedCampaign()!"
        [universeName]="selectedUniverse()?.name || ''"
      />

      <div class="button-row">
        <button
          type="button"
          class="primary-btn"
          [disabled]="isFinalizing()"
          (click)="finalizeSession()"
        >
          {{ isFinalizing() ? 'Finalizing Session...' : 'Finalize Session' }}
        </button>
      </div>
    </section>
  }
</section>
